import axios from "axios"
import { auth } from "../firebase/config"

// Create an axios instance with base configuration
const apiClient = axios.create({
  baseURL: "/api", // This will be relative to your deployed app
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
})

if (process.env.NODE_ENV === "development") {
  // In development mode, use the local API server
  apiClient.defaults.baseURL = "http://localhost:5000/api"
}

// Add a request interceptor to attach the auth token to every request
apiClient.interceptors.request.use(
  async (config) => {
    try {
      const currentUser = auth.currentUser
      if (currentUser) {
        const token = await currentUser.getIdToken()
        config.headers.Authorization = `Bearer ${token}`
      }
    } catch (error) {
      console.error("Error getting auth token:", error)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// Add a response interceptor to handle common errors
apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const originalRequest = error.config

    // If the error is due to an expired token and we haven't retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        // Force token refresh
        const currentUser = auth.currentUser
        if (currentUser) {
          await auth.currentUser?.getIdToken(true)
          // Retry the request with the new token
          return apiClient(originalRequest)
        }
      } catch (refreshError) {
        console.error("Error refreshing token:", refreshError)
      }
    }

    return Promise.reject(error)
  },
)

export default apiClient
